import { render, staticRenderFns } from "./modal-desativar-usuario.vue?vue&type=template&id=0692c7bf"
import script from "./modal-desativar-usuario.vue?vue&type=script&lang=js"
export * from "./modal-desativar-usuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports